  function updateWishlistButtonState(button, isInWishlist) {
    var icon = button.querySelector('.swym-heart-icon');
    if(icon) {
      var path = icon.querySelector('path');
      if(path) {
        if(isInWishlist) {
          path.setAttribute('fill', '#C14D2B');
          path.setAttribute('stroke', '#C14D2B');
          button.setAttribute('aria-label', 'Remove from wishlist');
          button.setAttribute('title', 'Remove from wishlist');
          button.classList.add('swym-in-wishlist');
        } else {
          path.setAttribute('fill', 'none');
          path.setAttribute('stroke', '#C14D2B');
          button.setAttribute('aria-label', 'Add to wishlist');
          button.setAttribute('title', 'Add to wishlist');
          button.classList.remove('swym-in-wishlist');
        }
      }
    }
  }

  function checkWishlistStates() {
    if(typeof _swat === 'undefined' || !_swat.fetchWrtEventTypeET) {
      return;
    }

    var wishlistButtons = document.querySelectorAll(".wishlist-btn");
    if(wishlistButtons.length === 0) return;

    _swat.fetchWrtEventTypeET(function(products){
      wishlistButtons.forEach(function(button){
        var productId = button.getAttribute("data-product-id");
        var variantId = button.getAttribute("data-variant-id");
        
        // For product pages, get current variant from hidden input
        var variantInput = document.querySelector('input[name="id"]');
        if(variantInput && variantInput.value) {
          variantId = variantInput.value;
          button.setAttribute("data-variant-id", variantId);
        }
        
        // Check if this product is in the wishlist
        var isInWishlist = products.find(function(p){
          return String(p.empi) === String(productId) && String(p.epi) === String(variantId);
        });
        
        updateWishlistButtonState(button, !!isInWishlist);
      });
    }, 4); // 4 = wishlist event type
  }

  // Function to check if user has given tracking consent
  function hasTrackingConsent() {
    if (window.Shopify && window.Shopify.customerPrivacy) {
      try {
        const result = window.Shopify.customerPrivacy.getTrackingConsent();
        // Consent can be: 'no_interaction', 'yes', 'no', true, or false
        return (result === 'yes' || result === true);
      } catch(e) {
        return false;
      }
    }
    return false;
  }

  // Function to show the cookie preferences banner
  function showCookieConsentPopup() {
    if (typeof window.showPreferences === 'function') {
      window.showPreferences(document.body);
      return;
    }
  }

  // Function to show a toast notification
  function showToast(message) {
    // Remove any existing toast
    const existingToast = document.getElementById('wishlist-consent-toast');
    if (existingToast) {
      existingToast.remove();
    }
    
    // Create toast element
    const toast = document.createElement('div');
    toast.id = 'wishlist-consent-toast';
    toast.style.cssText = 'position: fixed; bottom: 20px; left: 50%; transform: translateX(-50%) translateY(20px); background-color: #286581; color: white; padding: 12px 20px; border-radius: 9999px; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); z-index: 2147483647; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: 500; opacity: 0; transition: opacity 0.3s ease, transform 0.3s ease; pointer-events: none; text-align: center; max-width: calc(100% - 40px); width: auto; white-space: normal; word-break: normal; overflow-wrap: normal;';
    toast.textContent = message;
    
    // Add to body
    document.body.appendChild(toast);
    
    // Force reflow and animate in
    toast.offsetHeight; // Force reflow
    setTimeout(function() {
      toast.style.opacity = '1';
      toast.style.transform = 'translateX(-50%) translateY(0)';
    }, 10);
    
    // Auto remove after 4 seconds
    setTimeout(function() {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(20px)';
      setTimeout(function() {
        if (toast.parentNode) {
          toast.parentNode.removeChild(toast);
        }
      }, 300);
    }, 4000);
  }

  function swymCallbackFn(swat){
    // Check initial wishlist states
    checkWishlistStates();

    // Listen for Swym events to update all wishlist buttons when items are added/removed
    if(swat && swat.evtLayer){
      swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function() {
        // Update all wishlist buttons after a short delay to ensure Swym has updated
        setTimeout(function() {
          if (window.checkWishlistStates) {
            window.checkWishlistStates();
          }
        }, 200);
      });

      swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, function() {
        // Update all wishlist buttons after a short delay to ensure Swym has updated
        setTimeout(function() {
          if (window.checkWishlistStates) {
            window.checkWishlistStates();
          }
        }, 200);
      });
    }
  }

  // Set up click handler for wishlist header icon (menu icon)
  document.addEventListener("click", function(e){
    const target = e.target;
    let headerIcon = null;
    
    // Check if target itself is the button
    if (target.id === 'swym-header-icon') {
      headerIcon = target;
    } else {
      // Check if any parent is the button
      let parent = target.parentElement;
      while (parent && parent !== document.body) {
        if (parent.id === 'swym-header-icon') {
          headerIcon = parent;
          break;
        }
        parent = parent.parentElement;
      }
    }
    
    if(headerIcon) {
      // Check if user has given tracking consent
      if (!hasTrackingConsent()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showToast('Please accept cookies to use the wishlist!');
        setTimeout(showCookieConsentPopup, 500);
        return;
      }
    }
  }, true); 

  document.addEventListener("click", function(e){
    const wishlistButton = e.target.closest(".wishlist-btn");
    if(!wishlistButton) return;
    
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    // Check if user has given tracking consent
    if (!hasTrackingConsent()) {
      showToast('Please accept cookies to use the wishlist!');
      setTimeout(showCookieConsentPopup, 500);
      return;
    }
    
    // If Swym is loaded, proceed with the action
    if(typeof _swat !== 'undefined'){
      // Get current variant ID - check multiple sources
      let currentVariantId = wishlistButton.getAttribute("data-variant-id");
      
      // For product pages, try to get variant from hidden input first
      const variantInput = document.querySelector('input[name="id"]');
      if(variantInput && variantInput.value) {
        currentVariantId = variantInput.value;
      }
      
      // For collection pages, try to get from selected swatch
      if(!variantInput) {
        const card = wishlistButton.closest('[data-product-id]') || wishlistButton.closest('a[href*="/products/"]');
        if(card) {
          const selectedSwatch = card.querySelector('[data-hook="product-option"]:checked');
          if(selectedSwatch) {
            const variantId = selectedSwatch.getAttribute('data-variant-id');
            if(variantId) {
              currentVariantId = variantId;
            }
          }
        }
      }
      
      const productId = wishlistButton.getAttribute("data-product-id");
      const productUrl = wishlistButton.getAttribute("data-product-url");
      const productImage = wishlistButton.getAttribute("data-product-image");
      const productPrice = wishlistButton.getAttribute("data-product-price");
      const productTitle = wishlistButton.getAttribute("data-product-title");
      
      // Construct Swym data for collection pages
      const swymData = {
        empi: productId,
        epi: currentVariantId,
        du: productUrl,
        iu: productImage,
        pr: productPrice,
        dt: productTitle || '',  // dt = product title/description
        et: 4  // et 4 stands for wishlist event type
      };
      
      var isInWishlist = wishlistButton.classList.contains('swym-in-wishlist');
      
      // Function to open wishlist drawer
      function openWishlistDrawer() {
        const drawerTrigger = document.querySelector('[data-drawer="wishlist-drawer"]:not(.js-drawer-close)');
        if (drawerTrigger) {
          drawerTrigger.click();
        }
      }
      
      if(isInWishlist && _swat.removeFromWishList){
        // Remove from wishlist
        _swat.removeFromWishList(swymData, function(e){
          updateWishlistButtonState(wishlistButton, false);
          // Open wishlist drawer after removal
          setTimeout(openWishlistDrawer, 100);
        });
      } else if(!isInWishlist && _swat.addToWishList){
        // Add to wishlist
        _swat.addToWishList(swymData, function(e){
          updateWishlistButtonState(wishlistButton, true);
          // Open wishlist drawer after adding
          setTimeout(openWishlistDrawer, 100);
        });
      }
    }
  }, true);

  if(!window.SwymCallbacks){
   window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);

  // Make checkWishlistStates available globally so card.js can call it
  window.checkWishlistStates = checkWishlistStates;

  // Also check states when Swym loads 
  function checkSwymAndUpdate(){
    if(typeof _swat !== 'undefined' && _swat.fetchWrtEventTypeET) {
      checkWishlistStates();
    } else {
      setTimeout(checkSwymAndUpdate, 500);
    }
  }

  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkSwymAndUpdate);
  } else {
    checkSwymAndUpdate();
  }

  // Listen for custom event from card.js when variant changes
  if(typeof jQuery !== 'undefined') {
    jQuery(document).on('product-card:variant-changed', function(e, data) {
      setTimeout(function() {
        checkWishlistStates();
      }, 150);
    });
  }
  
  // Listen for search section rendering events to check wishlist states
  function handleSearchRenderingEvent(e) {
    setTimeout(function() {
      if (window.checkWishlistStates && typeof window.checkWishlistStates === 'function') {
        window.checkWishlistStates();
      }
    }, 100);
  }
  
  // Set up native event listeners
  document.addEventListener('search:section-rendered', handleSearchRenderingEvent);
  document.addEventListener('search:cards-rendered', handleSearchRenderingEvent);

  // Swym Header Icon Custom Element
  if(!customElements.get('swym-header-icon')){
    class SwymHeaderIcon extends HTMLElement{
        constructor(){
          super();
          if (!window.SwymCallbacks) window.SwymCallbacks = [];
          window.SwymCallbacks.push(this._initializeSwymButton.bind(this));
        }

        _initializeSwymButton(swat){
          this.button = this.querySelector('button');
          
          // Only add Swym default UI click handler if button doesn't have js-drawer-trigger class
          // (buttons with js-drawer-trigger use custom drawer instead)
          if (!this.button.classList.contains('js-drawer-trigger')) {
            this.button.addEventListener('click', _openWishlistUi);
          }

          function _openWishlistUi(evt){
            // Check if user has given tracking consent
            if (!hasTrackingConsent()) {
              evt.preventDefault();
              evt.stopPropagation();
              showCookieConsentPopup();
              return;
            }
            swat.ui.open();
          }
          
          // HEADER COUNTER CODE 
          this.counter = this.querySelector(".swym-wishlist-header-counter");
          this.svgPath = this.querySelector("svg path");
          this.swat = swat; // Store swat reference for refresh
          
          // Helper function to update button and icon color state
          const updateButtonState = (count) => {
            if(this.svgPath) {
              if(count > 0) {
                this.svgPath.style.stroke = '#286581';
                this.svgPath.style.transition = 'stroke 0.2s ease';
              } else {
                this.svgPath.style.stroke = 'black';
                this.svgPath.style.transition = 'stroke 0.2s ease';
              }
            }
          };
          
          // Function to refresh counter (called on init and when Swym re-initializes)
          const refreshCounter = () => {
            if(!this.counter || !swat.fetchLists) return;
            
            swat.fetchLists({
              callbackFn: (listData) => {
                // Remove the duplicate occurences of products
                let products = {};
                for (const list of listData) {
                  if (list.listcontents && list.listcontents.length > 0) {
                    for (const product of list.listcontents) {
                      const epi = product.epi;
                      if (!products[epi]) {
                        products[epi] = product;
                      }
                    }
                  }
                }
                const productCount = Object.values(products).length;
                
                this.counter.innerHTML = productCount;
                if(productCount > 0) {
                  this.counter.classList.remove('tw-hidden');
                } else {
                  this.counter.classList.add('tw-hidden');
                }
                updateButtonState(productCount);
              },
              onError: (error) => {
                console.error('Error fetching wishlist data:', error);
              }
            });
          };
          
          if(this.counter){
            const counter = this.counter; 
            
            // Increase header count when product is added to the list.
            swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, () => {
              const counterCount = +counter.innerHTML || 0;
              const newCount = counterCount + 1;
              counter.innerHTML = newCount; 
              counter.classList.remove('tw-hidden');
              updateButtonState(newCount);
            })

            // Decrease header count when product is removed from the list.
            swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, () => {
              const counterCount = +counter.innerHTML || 0;
              const newCount = counterCount - 1;
              if(newCount > 0) {
                counter.innerHTML = newCount;
                counter.classList.remove('tw-hidden');
              } else {
                counter.innerHTML = 0;
                counter.classList.add('tw-hidden');
              }
              updateButtonState(newCount);
            })
                  
            // Fetch total number of products and update header counter.
            setTimeout(() => {
              refreshCounter();
            }, 100);
          }
        }
    }
    customElements.define('swym-header-icon', SwymHeaderIcon);
  }

  // ============================================================================
  // SHARED UTILITY FUNCTIONS (used by both drawer and shared wishlist page)
  // ============================================================================

  // Fetch product data from Shopify
  async function fetchProductData(wishlist) {
    const productDataPromises = wishlist.map(async (listItem) => {
      try {
        const productUrl = listItem.du.split('?')[0];
        const response = await fetch(`${productUrl}.js`);
        if (response.ok) {
          listItem.productData = await response.json();
        }
        return listItem;
      } catch (error) {
        console.error('Error fetching product data:', error);
        return listItem;
      }
    });
    return await Promise.all(productDataPromises);
  }

  // Parse variant title to display color information
  function parseVariantName(variantTitle, productData) {
      if (!variantTitle) return '';
      
      let html = '';
      const hasColorOption = productData?.options?.some(opt => 
        opt.name === 'Color' || opt.name === 'Colour'
      );
      
      if (variantTitle.includes(' / ')) {
        const parts = variantTitle.split(' / ');
        const sizePart = parts[0]?.trim();
        const colorPart = parts[1]?.trim();
        
        if (sizePart) {
          html += `<div class="tw-text-xs tw-font-helvetica tw-text-fullblack tw-opacity-75">Size: ${sizePart}</div>`;
        }
        
        if (colorPart) {
          const swatchParts = colorPart.split('/');
          const exterior = swatchParts[0]?.trim() || '';
          const interior = swatchParts[1]?.trim() || '';
          
          // Parse exterior
          const exteriorWords = exterior.split(' ');
          let exteriorColor = exterior;
          let exteriorMaterial = '';
          for (let i = 0; i < exteriorWords.length; i++) {
            const word = exteriorWords[i].toLowerCase();
            if (word.includes('ballistic') || word.includes('halcyon') || word.includes('cordura') || word.includes('ripstop') || word.includes('x-pac')) {
              exteriorColor = exteriorWords.slice(0, i).join(' ');
              exteriorMaterial = exteriorWords.slice(i).join(' ');
              break;
            }
          }
          
          html += `<div class="tw-text-xs tw-font-helvetica tw-text-fullblack tw-opacity-75">Ex Color: ${exteriorColor}${exteriorMaterial ? '/' + exteriorMaterial : ''}</div>`;
          
          // Parse interior
          if (interior) {
            const interiorWords = interior.split(' ');
            let interiorColor = interior;
            let interiorMaterial = '';
            for (let i = 0; i < interiorWords.length; i++) {
              const word = interiorWords[i].toLowerCase();
              if (word.includes('ballistic') || word.includes('halcyon') || word.includes('cordura') || word.includes('ripstop') || word.includes('x-pac') || word.includes('cerylon')) {
                interiorColor = interiorWords.slice(0, i).join(' ');
                interiorMaterial = interiorWords.slice(i).join(' ');
                break;
              }
            }
            html += `<div class="tw-text-xs tw-font-helvetica tw-text-fullblack tw-opacity-75">Int Color: ${interiorColor}${interiorMaterial ? '/' + interiorMaterial : ''}</div>`;
          }
        }
      } else if (hasColorOption && variantTitle.includes('/')) {
        // Single color option with exterior/interior
        const swatchParts = variantTitle.split('/');
        const exterior = swatchParts[0]?.trim() || '';
        const interior = swatchParts[1]?.trim() || '';
        
        // Parse exterior
        const exteriorWords = exterior.split(' ');
        let exteriorColor = exterior;
        let exteriorMaterial = '';
        for (let i = 0; i < exteriorWords.length; i++) {
          const word = exteriorWords[i].toLowerCase();
          if (word.includes('ballistic') || word.includes('halcyon') || word.includes('cordura') || word.includes('ripstop') || word.includes('x-pac')) {
            exteriorColor = exteriorWords.slice(0, i).join(' ');
            exteriorMaterial = exteriorWords.slice(i).join(' ');
            break;
          }
        }
        
        html += `<div class="tw-text-xs tw-font-helvetica tw-text-fullblack tw-opacity-75">Ext. Color: ${exteriorColor}${exteriorMaterial ? '/' + exteriorMaterial : ''}</div>`;
        
        // Parse interior
        if (interior) {
          const interiorWords = interior.split(' ');
          let interiorColor = interior;
          let interiorMaterial = '';
          for (let i = 0; i < interiorWords.length; i++) {
            const word = interiorWords[i].toLowerCase();
            if (word.includes('ballistic') || word.includes('halcyon') || word.includes('cordura') || word.includes('ripstop') || word.includes('x-pac') || word.includes('cerylon')) {
              interiorColor = interiorWords.slice(0, i).join(' ');
              interiorMaterial = interiorWords.slice(i).join(' ');
              break;
            }
          }
          html += `<div class="tw-text-xs tw-font-helvetica tw-text-fullblack tw-opacity-75">Int. Color: ${interiorColor}${interiorMaterial ? '/' + interiorMaterial : ''}</div>`;
        }
      } else if (hasColorOption && !variantTitle.includes('/')) {
        const colorWords = variantTitle.split(' ');
        let colorName = variantTitle;
        let material = '';
        
        for (let i = 0; i < colorWords.length; i++) {
          const word = colorWords[i].toLowerCase();
          if (word.includes('ballistic') || word.includes('halcyon') || word.includes('cordura') || word.includes('ripstop') || word.includes('x-pac')) {
            colorName = colorWords.slice(0, i).join(' ');
            material = colorWords.slice(i).join(' ');
            break;
          }
        }
        
        html += `<div class="tw-text-xs tw-font-helvetica tw-text-fullblack tw-opacity-75">Ex Color: ${colorName}${material ? ' / ' + material : ''}</div>`;
      } else if (!productData?.has_only_default_variant) {
        // Other options - show as "Option: value"
        const options = productData?.options || [];
        options.forEach(option => {
          if (option.name !== 'Color' && option.name !== 'Colour') {
            html += `<p class="!tw-text-sm tw-p-0 tw-m-0 xl:!tw-text-sm 2xl:!tw-text-sm">
              <span class="mr-1 tw-text-xs tw-font-helvetica !tw-text-fullblack tw-opacity-75">${option.name}: </span>
              <span class="tw-text-xs tw-font-helvetica !tw-text-fullblack tw-opacity-75">${variantTitle}</span>
            </p>`;
          }
        });
      }
      
      return html;
  }

  // Render a single wishlist item (unified for both drawer and shared page)
  // options: { swat, showRemoveButton, buttonClass, onAddToCartSuccess, onRemove, checkCartState }
  function renderWishlistItem(item, options) {
    const { swat, showRemoveButton = false, buttonClass = 'js-wishlist-add-to-cart', onAddToCartSuccess, onRemove, checkCartState } = options || {};
    if (!swat) {
      console.error('renderWishlistItem: swat is required');
      return null;
    }

    const wishlistItem = document.createElement('li');
    wishlistItem.classList.add('tw-bg-paleblue', 'tw-rounded-lg', 'tw-p-3', 'tw-m-0', 'tw-h-[170px]', 'tw-relative');
    wishlistItem.dataset.epi = item.epi;
    wishlistItem.dataset.empi = item.empi;
    wishlistItem.dataset.du = item.du;

    // Use item.iu first - this is the image Swym stores when adding to wishlist
    const productImage = item.iu || item.productData?.featured_image || '';
    const selectedVariant = item.productData?.variants?.find(variant => String(variant.id) === String(item.epi));
    const isAvailable = selectedVariant?.available !== false;
    wishlistItem.dataset.available = isAvailable;
    
    // Check cart state - use custom function if provided, otherwise use Swym default
    let isInCart = false;
    const variantId = selectedVariant?.id;
    if (checkCartState && typeof checkCartState === 'function') {
      isInCart = checkCartState(variantId);
    } else {
      isInCart = swat.platform.isInDeviceCart(variantId);
    }
    
    const addToCartText = isInCart ? 'Added to Cart' : (isAvailable ? 'Add to Cart' : 'Sold Out');
    const currency = swat.currency || '$';
    const price = item.pr ? parseFloat(item.pr) : (selectedVariant?.price ? selectedVariant.price / 100 : 0);
    const formattedPrice = price ? currency + price.toFixed(2) : '';
    
    // Parse variant name for display
    const variantNameHtml = selectedVariant?.title ? parseVariantName(selectedVariant.title, item.productData) : '';
    const productTitle = item.productData?.title || item.dt || 'Product';

    const removeButtonHtml = showRemoveButton ? `
      <div class="tw-flex tw-justify-end tw-w-full">
        <button 
          class="js-wishlist-remove tw-flex tw-items-center tw-justify-center tw-transition-colors" 
          aria-label="Remove from wishlist"
          data-empi="${item.empi}"
          data-epi="${item.epi}"
          data-du="${item.du}"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path d="M18 6.5L6 18.5M6 6.5L18 18.5" stroke="#181D27" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    ` : '';

    wishlistItem.innerHTML = `
      <div class="tw-flex tw-items-stretch tw-justify-between tw-h-full">
        <!-- Left side: Image + Content grouped together -->
        <div class="tw-flex tw-items-stretch tw-h-full tw-min-w-0" style="gap: 12px;">
          <!-- Image -->
          <div class="tw-w-24 tw-flex-shrink-0 tw-flex tw-flex-col">
            <a href="${item.du}" class="tw-h-full tw-flex tw-flex-col">
              <img 
                src="${productImage}" 
                alt="${productTitle}" 
                class="tw-object-cover tw-w-full tw-h-full tw-rounded tw-mix-blend-multiply" 
                style="mix-blend-mode: multiply; -webkit-mix-blend-mode: multiply; transform: translateZ(0); -webkit-transform: translateZ(0); isolation: isolate; -webkit-isolation: isolate; will-change: transform; backface-visibility: hidden; -webkit-backface-visibility: hidden;"
                loading="lazy"
              />
            </a>
          </div>

          <!-- Content -->
          <div class="tw-flex tw-flex-col tw-justify-between tw-h-full tw-min-w-0 tw-flex-1">
            <!-- Product Info Group -->
            <div class="tw-min-w-0">
              <!-- Product Title -->
              <h3 class="lg:tw-text-[22px] tw-text-base tw-font-medium tw-normal-case tw-font-neutraface-text tw-p-0 tw-m-0 tw-leading-none">
                <a href="${item.du}" class="tw-text-fullblack hover:tw-text-blue tw-font-neutraface-text ">${productTitle}</a>
              </h3>

              ${variantNameHtml ? `<div class="tw-mt-1">${variantNameHtml}</div>` : ''}
            </div>

            <!-- Add to Cart Button -->
            <div>
              <button 
                class="${buttonClass} tw-w-[160px] sm:tw-w-[252px] tw-px-4 tw-py-2 tw-bg-blue tw-text-white tw-rounded-full hover:tw-bg-aqua tw-transition-colors tw-font-helvetica tw-text-[14px] tw-font-medium tw-leading-6 ${!isAvailable || isInCart ? 'tw-opacity-70 tw-cursor-not-allowed' : ''}" 
                data-action="add-to-cart"
                data-empi="${item.empi}"
                data-epi="${item.epi}"
                data-du="${item.du}"
                ${!isAvailable || isInCart ? 'disabled' : ''}
              >
                ${addToCartText}
              </button>
            </div>
          </div>
        </div>

        <!-- Right side: Price at top, Remove button at bottom (if enabled) -->
        <div class="tw-flex tw-items-end tw-justify-end tw-flex-shrink-0 tw-flex-col tw-justify-between tw-h-full tw-ml-2">
          <!-- Price at top -->
          <div class="tw-flex tw-items-center tw-justify-end tw-w-full">
            <span class="tw-font-medium tw-font-helvetica tw-leading-none lg:tw-text-lg tw-text-base">
              ${formattedPrice}
            </span>
          </div>
          ${removeButtonHtml}
        </div>
      </div>
    `;

    // Add to cart handler
    const addToCartBtn = wishlistItem.querySelector('[data-action="add-to-cart"]');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        if (!isAvailable) return;

        const originalText = this.innerHTML;
        this.innerHTML = 'Adding...';
        this.disabled = true;

        const swymData = {
          empi: item.empi,
          du: item.du,
          qty: item.qty || 1
        };

        swat.replayAddToCart(
          swymData,
          item.epi,
          function(success) {
            this.innerHTML = 'Added to Cart';
            this.disabled = true;
            this.classList.add('tw-opacity-70', 'tw-cursor-not-allowed');
            
            // Refresh cart to show the newly added item
            setTimeout(function() {
              const { cart: cartAPI, slideCart } = window.osAPI || {};
              if (cartAPI && cartAPI.getCart && slideCart && slideCart.render) {
                cartAPI.getCart().then(slideCart.render).catch(function(error) {
                  console.error('Error refreshing cart:', error);
                });
              }
            }, 100);
            
            // Call custom success handler if provided
            if (onAddToCartSuccess && typeof onAddToCartSuccess === 'function') {
              onAddToCartSuccess.call(this, success);
            }
          }.bind(this),
          function(error) {
            this.innerHTML = originalText;
            this.disabled = false;
            
            // Show error notification
            if (swat.ui && swat.ui.showErrorNotification) {
              swat.ui.showErrorNotification({ message: error.description || 'Failed to add to cart' });
            }
          }.bind(this)
        );
      });
    }

    // Remove from wishlist handler (only if enabled)
    if (showRemoveButton) {
      const removeBtn = wishlistItem.querySelector('.js-wishlist-remove');
      if (removeBtn && onRemove && typeof onRemove === 'function') {
        removeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          onRemove.call(this, item, wishlistItem);
        });
      }
    }

    return wishlistItem;
  }

  // ============================================================================
  // WISHLIST DRAWER FUNCTIONALITY
  // ============================================================================

  // Wishlist Drawer Functionality
  function initWishlistDrawer(swat) {
    const drawer = document.getElementById('wishlist-drawer');
    if (!drawer) return;

    const itemsContainer = document.getElementById('wishlist-drawer-items-container');
    const emptyContainer = document.getElementById('wishlist-drawer-empty');
    const itemCountElement = document.getElementById('wishlist-item-count');

    // Function to update item count in header
    function updateItemCount(count) {
      if (itemCountElement) {
        itemCountElement.textContent = count;
      }
    }

    // Function to show/hide UI states
    function showItems() {
      if (itemsContainer) itemsContainer.classList.remove('tw-hidden');
      if (emptyContainer) emptyContainer.classList.add('tw-hidden');
      updateShareButtonVisibility(true);
    }

    function showEmpty() {
      if (itemsContainer) itemsContainer.classList.add('tw-hidden');
      if (emptyContainer) emptyContainer.classList.remove('tw-hidden');
      updateItemCount(0);
      updateShareButtonVisibility(false);
    }

    // Function to show/hide share button based on wishlist state
    function updateShareButtonVisibility(hasItems) {
      const shareButton = document.getElementById('wishlist-share-button');
      if (shareButton) {
        if (hasItems) {
          shareButton.classList.remove('tw-hidden');
        } else {
          shareButton.classList.add('tw-hidden');
        }
      }
    }

    // Fetch and render wishlist
    async function fetchWishlist() {
      swat.fetchLists({
        callbackFn: async function(lists) {
          if (!lists || lists.length === 0) {
            showEmpty();
            return;
          }

          // Get all products from all lists (remove duplicates by epi)
          let allProducts = {};
          for (const list of lists) {
            if (list.listcontents && list.listcontents.length > 0) {
              for (const product of list.listcontents) {
                const epi = product.epi;
                if (!allProducts[epi]) {
                  allProducts[epi] = product;
                }
              }
            }
          }

          const uniqueProducts = Object.values(allProducts);

          if (uniqueProducts.length === 0) {
            showEmpty();
            return;
          }

          // Fetch product data and render
          const productsWithData = await fetchProductData(uniqueProducts);
          
          if (itemsContainer) {
            itemsContainer.innerHTML = '';
            productsWithData.forEach(function(item) {
              const itemElement = renderWishlistItem(item, {
                swat: swat,
                showRemoveButton: true,
                buttonClass: 'js-wishlist-add-to-cart',
                onAddToCartSuccess: function(success) {
                  // Close wishlist drawer and open cart
                  setTimeout(function() {
                    const drawerCloseBtn = document.querySelector('.js-drawer-close[data-drawer="wishlist-drawer"]');
                    if (drawerCloseBtn) {
                      drawerCloseBtn.click();
                    }
                    
                    const cartToggleBtn = document.querySelector('[data-hook="toggle-cart"]');
                    if (cartToggleBtn) {
                      setTimeout(function() {
                        cartToggleBtn.click();
                      }, 500);
                    }
                  }, 300);
                },
                onRemove: function(item, wishlistItem) {
                  const product = {
                    epi: item.epi,
                    empi: item.empi,
                    du: item.du
                  };

                  swat.fetchLists({
                    callbackFn: function(lists) {
                      if (lists && lists.length > 0) {
                        const listId = lists[0].lid;
                        swat.deleteFromList(
                          listId,
                          product,
                          function() {
                            wishlistItem.remove();
                            fetchWishlist();
                          },
                          function(error) {
                            console.error('Failed to remove from wishlist', error);
                          }
                        );
                      }
                    },
                    errorFn: function(error) {
                      console.error('Error fetching lists for removal', error);
                    }
                  });
                }
              });
              itemsContainer.appendChild(itemElement);
            });
          }

          // Update item count
          updateItemCount(uniqueProducts.length);
          showItems();
        },
        errorFn: function(error) {
          console.error('Error fetching wishlist:', error);
          showEmpty();
        }
      });
    }

    // Listen for drawer open event
    // Check when drawer gets 'active' class or when it's opened
    let lastDrawerState = false;
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isActive = drawer.classList.contains('active');
          const isVisible = !drawer.classList.contains('tw-hidden');
          const isOpen = isActive && isVisible;
          
          // Only fetch if drawer just opened (was closed, now open)
          if (isOpen && !lastDrawerState) {
            // Small delay to ensure drawer is fully rendered
            setTimeout(function() {
              fetchWishlist();
            }, 100);
          }
          
          lastDrawerState = isOpen;
        }
      });
    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class']
    });

    // Also listen for clicks on drawer trigger buttons
    const drawerTriggers = document.querySelectorAll('[data-drawer="wishlist-drawer"]');
    drawerTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        // Wait a bit for drawer to open, then fetch
        setTimeout(function() {
          if (drawer.classList.contains('active') && !drawer.classList.contains('tw-hidden')) {
            fetchWishlist();
          }
        }, 150);
      });
    });

    // Also listen for jQuery events if available
    if (typeof jQuery !== 'undefined') {
      jQuery(drawer).on('drawer:opened', function() {
        fetchWishlist();
      });
    }

    // Listen for Swym events to refresh wishlist when items are added/removed
    if (swat.evtLayer) {
      swat.evtLayer.addEventListener(swat.JSEvents.addedToWishlist, function() {
        if (drawer.classList.contains('active')) {
          fetchWishlist();
        }
      });

      swat.evtLayer.addEventListener(swat.JSEvents.removedFromWishlist, function() {
        if (drawer.classList.contains('active')) {
          fetchWishlist();
        }
      });
    }

    // Share button functionality - generates shareable URL
    const shareButton = document.getElementById('wishlist-share-button');
    if (shareButton) {
      shareButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        
        // Get wishlist items from the drawer
        const wishlistItems = itemsContainer?.querySelectorAll('li[data-epi]');
        
        if (!wishlistItems || wishlistItems.length === 0) {
          return;
        }
        
        // Store original button text
        const originalText = shareButton.textContent.trim();
        shareButton.textContent = 'Generating...';
        shareButton.disabled = true;
        
        // Helper function to build and copy share URL
        function buildAndCopyShareUrl(hkey, listId) {
          const baseUrl = window.location.origin;
          const params = new URLSearchParams({
            view: 'swym-share-wishlist',
            hkey: hkey,
            lid: listId,
            utm_source: 'swym-Wishlist',
            utm_medium: 'shared-wishlist',
            utm_campaign: hkey
          });
          const fullShareUrl = baseUrl + '/pages/shared-wishlist?' + params.toString();
          
          // Try Clipboard API first
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(fullShareUrl).then(function() {
              shareButton.textContent = 'Copied!';
              setTimeout(function() {
                shareButton.textContent = originalText;
                shareButton.disabled = false;
              }, 2000);
            }).catch(function() {
              // If Clipboard API fails, show URL in modal for easy copying
              showUrlForCopy(fullShareUrl);
            });
          } else {
            // No Clipboard API, show URL in modal
            showUrlForCopy(fullShareUrl);
          }
        }
        
        // Show URL in hidden input overlay for copying without modal
        function showUrlForCopy(url) {
          // Get button position and size
          var rect = shareButton.getBoundingClientRect();
          
          // Create invisible input positioned exactly over the button
          var input = document.createElement('input');
          input.type = 'text';
          input.value = url;
          input.readOnly = true;
          input.style.cssText = 'position: fixed; top: ' + rect.top + 'px; left: ' + rect.left + 'px; width: ' + rect.width + 'px; height: ' + rect.height + 'px; padding: 0; margin: 0; border: none; outline: none; background: transparent; opacity: 0; z-index: 10000; pointer-events: auto; font-size: 1px;';
          
          // Make button non-clickable, input will catch the click
          shareButton.style.pointerEvents = 'none';
          
          document.body.appendChild(input);
          
          // Helper to cleanup
          function cleanup() {
            if (input.parentNode) {
              document.body.removeChild(input);
            }
            shareButton.style.pointerEvents = 'auto';
          }
          
          // Helper to copy
          function attemptCopy() {
            input.select();
            if (input.setSelectionRange) {
              input.setSelectionRange(0, url.length);
            }
            
            try {
              if (document.execCommand('copy')) {
                cleanup();
                shareButton.textContent = 'Copied!';
                setTimeout(function() {
                  shareButton.textContent = originalText;
                  shareButton.disabled = false;
                }, 2000);
                return true;
              }
            } catch (e) {
              // Continue
            }
            return false;
          }
          
          // Copy when user taps (which hits the invisible input)
          input.addEventListener('click', function() {
            attemptCopy();
          });
          
          // Also try on focus (needed for Safari mobile)
          input.addEventListener('focus', function() {
            if (!attemptCopy()) {
              // If focus copy didn't work, wait for click
            }
          });
          
          // Auto-focus the input so it's ready (needed for Safari mobile)
          setTimeout(function() {
            input.focus();
          }, 50);
        }
        
        // Get the first list ID from Swym
        swat.fetchLists({
          callbackFn: function(lists) {
            if (!lists || lists.length === 0) {
              shareButton.textContent = originalText;
              shareButton.disabled = false;
              return;
            }
            
            const listId = lists[0].lid;
            
            // Generate shareable URL using Swym's shareList API
            if (swat.shareList) {
              swat.shareList(listId, function(shareData) {
                // Get hkey from shareData
                let hkey = listId; // Default to listId
                
                if (typeof shareData === 'string') {
                  hkey = shareData;
                } else if (shareData && typeof shareData === 'object') {
                  hkey = shareData.hkey || shareData.url || listId;
                }
                
                buildAndCopyShareUrl(hkey, listId);
              }, function(error) {
                console.error('Error sharing wishlist:', error);
                // Fallback: use listId as hkey
                buildAndCopyShareUrl(listId, listId);
              });
            } else {
              // Fallback: use listId as hkey
              buildAndCopyShareUrl(listId, listId);
            }
          },
          errorFn: function(error) {
            console.error('Error fetching lists for sharing:', error);
            shareButton.textContent = originalText;
            shareButton.disabled = false;
          }
        });
      });
    }
  }

  // ============================================================================
  // SHARED WISHLIST PAGE FUNCTIONALITY
  // ============================================================================

  // Shared Wishlist Page Functionality
  function initSharedWishlist(swat) {
    // Check if we're on a shared wishlist page
    const urlParams = new URLSearchParams(window.location.search);
    const view = urlParams.get('view');
    const lid = urlParams.get('lid');

    // Create containers dynamically if they don't exist
    let itemsContainer = document.getElementById('shared-wishlist-items-container');
    let emptyContainer = document.getElementById('shared-wishlist-empty');
    let itemCountElement = document.getElementById('shared-wishlist-item-count');
    let loadingContainer = document.getElementById('shared-wishlist-loading');
  
    // Function to update item count
    function updateItemCount(count) {
      if (itemCountElement) {
        itemCountElement.textContent = count;
      }
    }

    // Function to show/hide UI states
    function showItems() {
      if (loadingContainer) loadingContainer.classList.add('tw-hidden');
      if (itemsContainer) itemsContainer.classList.remove('tw-hidden');
      if (emptyContainer) emptyContainer.classList.add('tw-hidden');
    }

    function showEmpty() {
      if (loadingContainer) loadingContainer.classList.add('tw-hidden');
      if (itemsContainer) itemsContainer.classList.add('tw-hidden');
      if (emptyContainer) emptyContainer.classList.remove('tw-hidden');
      updateItemCount(0);
    }

    // Helper function to check cart state (uses Shopify cart API first, then Swym)
    function checkCartState(variantId) {
      const { cart: cartAPI } = window.osAPI || {};
      if (cartAPI && cartAPI.getItemByID && variantId) {
        const cartItems = cartAPI.getItemByID(variantId);
        return cartItems && cartItems.length > 0;
      }
      return swat.platform.isInDeviceCart(variantId);
    }

    // Fetch and render shared wishlist using fetchListDetails
    async function fetchSharedWishlist() {
      if (!lid) {
        console.error('[Swym Shared Wishlist] No lid found in URL parameters');
        showEmpty();
        return;
      }

      // Use fetchListDetails API for shared wishlists
      // API signature: swat.fetchListDetails(listConfig, onSuccess, onError)
      if (swat.fetchListDetails) {
        // Create listConfig object with lid (only use lid, not hkey)
        const listConfig = {
          "lid": lid
        };

        swat.fetchListDetails(
          listConfig,
          function(listDetails) {
            
            // listDetails should contain the list contents
            if (!listDetails) {
              showEmpty();
              return;
            }

            // The response structure is: listDetails.list.listcontents
            // Also check for listDetails.items or listDetails.listcontents as fallbacks
            let products = null;
            
            if (listDetails.list && listDetails.list.listcontents && listDetails.list.listcontents.length > 0) {
              products = listDetails.list.listcontents;
            } else if (listDetails.items && listDetails.items.length > 0) {
              products = listDetails.items;
            } else if (listDetails.listcontents && listDetails.listcontents.length > 0) {
              products = listDetails.listcontents;
            }

            if (!products || products.length === 0) {
              showEmpty();
              return;
            }

            const listInfo = listDetails.list || {};
            const userInfo = listInfo.userinfo || {};
            
            // Try to get first name from userinfo, fallback to email
            let creatorName = '';
            
            if (userInfo.fname) {
              creatorName = userInfo.fname;
            } else {
              const creatorEmail = listInfo.cby || listInfo.uby || '';
              if (creatorEmail) {
                const emailName = creatorEmail.split('@')[0];
                creatorName = emailName.charAt(0).toUpperCase() + emailName.slice(1).split('.')[0];
              }
            }
            
            // Update the title with creator's name
            const titleElement = document.getElementById('shared-wishlist-title');
            if (titleElement && creatorName) {
              titleElement.textContent = creatorName + "'s Shared Wishlist";
            }

            // Fetch product data and render
            fetchProductData(products).then(function(productsWithData) {
              if (itemsContainer) {
                itemsContainer.innerHTML = '';
                productsWithData.forEach(function(item) {
                  const itemElement = renderWishlistItem(item, {
                    swat: swat,
                    showRemoveButton: false,
                    buttonClass: 'js-shared-wishlist-add-to-cart',
                    checkCartState: checkCartState,
                    onAddToCartSuccess: function(success) {
                      // Open cart drawer
                      setTimeout(function() {
                        const cartToggleBtn = document.querySelector('[data-hook="toggle-cart"]');
                        if (cartToggleBtn) {
                          cartToggleBtn.click();
                        }
                      }, 200);
                    }
                  });
                  itemsContainer.appendChild(itemElement);
                });
              }

              // Update item count
              updateItemCount(products.length);
              showItems();
            }).catch(function(error) {
              console.error('[Swym Shared Wishlist] Error fetching product data:', error);
              showEmpty();
            });
          },
          function(error) {
            console.error('[Swym Shared Wishlist] Error fetching shared wishlist:', error);
            showEmpty();
          }
        );
      } else {
        console.error('[Swym Shared Wishlist] swat.fetchListDetails is not available');
        showEmpty();
      }
    }

    // Function to update button states without re-rendering everything
    function updateButtonStates() {
      if (!itemsContainer) return;
      
      const buttons = itemsContainer.querySelectorAll('[data-action="add-to-cart"]');
      const { cart: cartAPI } = window.osAPI || {};
      
      buttons.forEach(function(button) {
        const variantId = button.dataset.epi;
        if (!variantId) return;
        
        let isInCart = false;
        
        // Check cart state
        if (cartAPI && cartAPI.getItemByID) {
          const cartItems = cartAPI.getItemByID(variantId);
          isInCart = cartItems && cartItems.length > 0;
        } else if (swat && swat.platform && swat.platform.isInDeviceCart) {
          isInCart = swat.platform.isInDeviceCart(variantId);
        }
        
        // Update button state
        if (isInCart) {
          button.textContent = 'Added to Cart';
          button.disabled = true;
          button.classList.add('tw-opacity-70', 'tw-cursor-not-allowed');
        } else {
          const li = button.closest('li');
          const isAvailable = li?.dataset.available !== 'false';
          button.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
          button.disabled = !isAvailable;
          if (!isAvailable) {
            button.classList.add('tw-opacity-70', 'tw-cursor-not-allowed');
          } else {
            button.classList.remove('tw-opacity-70', 'tw-cursor-not-allowed');
          }
        }
      });
    }

    // Debounce helper
    function debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    // Debounced version to prevent rapid calls
    const debouncedUpdateButtons = debounce(updateButtonStates, 200);

    // Listen for cart update events - only update button states, don't re-render
    const { cart: cartAPI, slideCart } = window.osAPI || {};
    
    // Listen to cart API 'done' event (fires when cart requests complete)
    if (cartAPI && cartAPI.on) {
      cartAPI.on('done', function() {
        debouncedUpdateButtons();
      });
    }
    
    // Listen to slideCart 'update' event (fires when cart is rendered)
    if (slideCart && typeof jQuery !== 'undefined') {
      const $slideCart = jQuery('[data-section-id]').first();
      if ($slideCart.length) {
        $slideCart.on('SlideCart.update', function() {
          debouncedUpdateButtons();
        });
      }
    }
    
    // Also listen for DOM events as fallback
    document.addEventListener('cart:updated', function() {
      debouncedUpdateButtons();
    });
    
    // Listen for visibility change to refresh when user comes back to tab
    let visibilityTimeout;
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) {
        clearTimeout(visibilityTimeout);
        visibilityTimeout = setTimeout(function() {
          updateButtonStates();
        }, 300);
      }
    });

    // Fetch shared wishlist when Swym loads
    fetchSharedWishlist();
  }

  // Initialize wishlist drawer when Swym loads
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(initWishlistDrawer);
  
  // Initialize shared wishlist page when Swym loads
  window.SwymCallbacks.push(initSharedWishlist);
